import { Ref } from "react";
import { Checkbox as MantineCheckbox, CheckboxProps as MantineCheckboxProps } from "@mantine/core";

export interface CheckboxProps extends MantineCheckboxProps {
  padding?: string;
  ref?: Ref<HTMLInputElement>;
}

function Checkbox({ ref, ...props }: CheckboxProps) {
  return <MantineCheckbox {...props} ref={ref} radius="0" color="black" autoContrast={true} />;
}

export default Checkbox;
